import { useEffect, useState } from "react"
import "./mobileCartItem.css"

export function MobileCartItem({ itemId, cartItem, itemQuantity, cartClone, setCartClone }) {
    const [quantity, setQuantity] = useState(itemQuantity)

    useEffect(() => {
        const updatedCart = cartClone.map(e => {
            if (e.customId === itemId) {
                return { ...e, quantity }
            } else {
                return e
            }
        })
        setCartClone(updatedCart)
    }, [quantity])

    function removeCartItem() {
        const updatedCart = cartClone.filter(e => e.customId !== itemId)
        setCartClone(updatedCart)
    }

    return (
        <div className="mobile-cart-item rounded-1 d-flex flex-column position-relative p-4">

            <div className="position-absolute delete-icon" onClick={removeCartItem}></div>

            <div className="d-flex justify-content-center img-box p-3">
                <img src={cartItem.image} alt="" />
            </div>

            <div className="my-4 text-black cart-item-title">{cartItem.title}</div>

            <div className="d-flex flex-column align-items-center mt-auto gap-3">

                <div className="d-flex justify-content-center quantity-section">
                    <div
                        className="quantity-btns"
                        onClick={() => quantity > 1 && setQuantity(quantity - 1)}>
                    </div>
                    <input
                        type="number"
                        value={quantity}
                        onChange={(e) => setQuantity(e.target.value)}
                    />
                    <div
                        className="quantity-btns"
                        onClick={() => setQuantity(quantity + 1)}>
                    </div>
                </div>

                <div>
                    <h3 className="fw-normal text-black subtotal">
                        Subtotal : ${
                            parseFloat((
                                (cartItem.salePrice ? cartItem.salePrice : cartItem.regularPrice) * quantity
                            ).toPrecision(6))
                        }
                    </h3>
                </div>

            </div>
            
        </div>
    )
}